import React, { useCallback, useState } from 'react';

/* React Redux */
import { useSelector, useDispatch } from 'react-redux';

/* React Router */
import { useNavigate } from 'react-router-dom';

/* Project */
import { LoginForm, LoginSelector, LoginSnackbars } from 'content/features/authentication';
import { validateEmail, validatePassword } from 'utils/functions';
import { controlsChanged, login } from 'content/features/authentication/login/login.actions';
import { toggleErrorMessage, toggleSuccessMessage } from '../../app.actions';

const { page: loginSelector } = LoginSelector;

function Login() {
  const [errors, setErrors] = useState({ email: {}, password: {} });

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const states = useSelector(loginSelector);

  const { controls, error, errorMsg, success, successMsg, loading } = states;
  const { email, password } = controls;

  const onChangeText = useCallback(({ target: { id, value } }) => {
    dispatch(controlsChanged({ name: id, value }));
  }, []);

  const toggleError = () => dispatch(toggleErrorMessage());
  const toggleSuccess = () => dispatch(toggleSuccessMessage());

  const goToHome = () => navigate('/');

  const validateFields = () => {
    const currentErrors = {
      email: validateEmail(email),
      password: validatePassword(password),
    };

    setErrors(currentErrors);

    return currentErrors;
  };

  const handleLogin = () => {
    const validAuth = () => Object.values(validateFields()).every((fieldError) => fieldError.check);

    if (validAuth()) {
      const formattedEmail = email.toLowerCase();
      dispatch(login({ email: formattedEmail, password }));
    }
  };

  const content = (
    <LoginForm
      handleLogin={handleLogin}
      controls={controls}
      errors={errors}
      onChangeText={onChangeText}
      loading={loading}
      goToHome={goToHome}
    />
  );

  const snackbars = (
    <LoginSnackbars
      toggleError={toggleError}
      toggleSuccess={toggleSuccess}
      error={error}
      errorMsg={errorMsg}
      success={success}
      successMsg={successMsg}
    />
  );

  return (
    <>
      {content}
      {snackbars}
    </>
  );
}

export default Login;
